import { toTypedSchema } from '@vee-validate/zod'
import { object, string } from 'zod'

export const questionnaireSchema = toTypedSchema(
  object({
    answer: string().max(500, 'common.validation.maxChars').min(4, 'common.validation.minDetails'),
  })
)
